﻿import {RefObject, useEffect} from "react";
import {useLocation} from "react-router";
import {getHtmlElement} from "./getHtmlElement";

export function useScrollToTop(mainRef: RefObject<HTMLElement | null> | HTMLElement | string): void {
	const location = useLocation();
	useEffect(() => {
		const element = getHtmlElement(mainRef);
		if (!element) return;

		element.scrollTop = 0;
	}, [location.pathname, mainRef]);
}
